<template>
  <div class="home-page-wrap" :class="{ 'h5-home-page-wrap': isH5, 'electron-home-page': isElectron }">
    <!-- 公告 -->
    <Notice
      v-if="layout.affiche && layout.affiche.length"
      :noticeList="layout.affiche"
    />
    <!-- Hero Banner -->
    <HeroBanner
      v-if="layout.banner && layout.banner.length"
      :bannerList="layout.banner || []"
    />
    <div
      class="content home-content"
      :class="{
        'electron-home-content': isElectron,
      }"
    >
      <!-- 热门课程分类 -->
      <section class="py-3 md:py-12">
        <div class="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8">
          <CourseCategories :userCategories="userCategories" @openDrawer="handleOpenDrawer" />
        </div>
      </section>

      <!-- 精品课程 - 白色背景区域 -->
      <section v-if="layout.course && layout.course.length" class="courses-section relative bg-white dark:bg-slate-900 mt-4 md:mt-8 border-t border-black/[0.03] dark:border-white/[0.06] py-6 md:py-12 pb-10 md:pb-20 transition-colors duration-300">
        <div class="courses-section-line"></div>
        <div class="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <Courses :couseList="layout.course" />
        </div>
      </section>

      <!-- 推荐机构 - 渐变装饰背景 -->
      <section v-if="layout.org && layout.org.length" class="institutions-section relative py-6 md:py-12 pb-10 md:pb-20 overflow-hidden">
        <div class="institutions-gradient-bg absolute top-0 right-0 w-full h-full pointer-events-none"></div>
        <div class="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <OrgList :orgList="layout.org" />
        </div>
      </section>
    </div>
    <ClassifyDrawer ref="classifyDrawer" @saveCategory="handleSaveCategory" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCategoryList, saveCategory } from "@saas/service-api/src/category";
import { getLocalCategories, saveLocalCategories } from "./utils/categoryStorage";
import ClassifyDrawer from "./components/ClassifyDrawer.vue";
import { getHomepage } from "@saas/service-api/src/layout";
import { getCourseState } from "@saas/service-api/src/course";
import CourseCategories from "./components/CourseCategories";
import OrgList from "./components/OrgList";
import Courses from "./components/Courses";
import HeroBanner from "./components/HeroBanner.vue";
import Notice from "./components/Notice.vue";
import { isH5 } from "@saas/components";

export default {
  data: function () {
    return {
      isH5: isH5(),
      isElectron: false,
      layout: {},
      userCategories: [],
    };
  },
  mounted() {
    this.isElectron = window.isElectron;
    this.loadUserCategories();
    this.apiGetHomepage();
  },
  methods: {
    // 加载用户分类数据
    loadUserCategories(sync = true) {
      // 第一优先级：localStorage
      const localData = getLocalCategories();
      if (localData.length) {
        this.userCategories = localData;
        if (sync && this.isAuthenticated) {
          saveCategory({ category_id: localData.map(c => c.id) })
            .catch(() => {});
        }
        return;
      }
      // 第二优先级：API
      getCategoryList().then((res) => {
        if (res.code === 1) {
          const data = res.data || [];
          this.userCategories = data;
          saveLocalCategories(data.map(c => ({ id: c.id, category_name: c.category_name, pid: c.pid })));
        }
      });
    },
    handleSaveCategory() {
      this.loadUserCategories(false);
    },
    handleOpenDrawer() {
      if (this.$refs.classifyDrawer) {
        this.$refs.classifyDrawer.openDrawer();
      }
    },
    apiGetHomepage() {
      let params = {};
      if (this.$route.query.preview) {
        params.preview = 1;
      }
      getHomepage(params).then((res) => {
        if (res.code === 1) {
          this.layout = res.data || {};
          let courseIds = []; //首页推荐展示课程ids
          let courseList = []; //首页推荐展示课程信息汇总
          // 精品课
          if (this.layout?.course?.length) {
            this.layout.course.forEach((course, index) => {
              this.layout.course[index] = {
                ...course,
                ...course.course_info,
                // 添加模块标识
                moduleName: "course",
                index,
              };
              if (course?.course_info.id) {
                courseIds.push(course?.course_info.id);
                courseList.push(this.layout.course[index]);
              }
            });
          }
          // 推荐机构
          if (this.layout?.org?.length) {
            this.layout.org.forEach((org, index) => {
              if (org?.course_list?.length) {
                // 添加模块标识
                org.course_list[0].moduleName = "org";
                org.course_list[0].index = index;
                courseIds.push(org?.course_list[0].id);
                courseList.push(org.course_list[0]);
              }
            });
          }
          if (courseIds?.length) {
            // 获取课程状态
            getCourseState({
              course_id: courseIds.join(","),
            }).then((res) => {
              if (res.code === 1 && res.data?.length) {
                let haveStatusIds = res.data.map((item) => item.course_id);
                courseList.forEach((course) => {
                  if (haveStatusIds.includes(course.id)) {
                    let { trial_state, live_state } = res.data.find(
                      (element) => element.course_id === course.id
                    );
                    let { moduleName, index } = course;
                    if (moduleName === "org") {
                      this.$set(this.layout[moduleName][index], "course_list", [
                        {
                          ...course,
                          trial_state,
                          live_state,
                        },
                      ]);
                    } else {
                      this.$set(this.layout[moduleName], index, {
                        ...course,
                        trial_state,
                        live_state,
                      });
                    }
                  }
                });
              }
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
  },
  components: {
    CourseCategories,
    OrgList,
    Courses,
    Notice,
    HeroBanner,
    ClassifyDrawer,
  },
};
</script>

<style lang="scss" scoped>
.home-page-wrap {
  position: relative;
  background: var(--page-bg);
  width: 100%;
  min-height: calc(100vh - 50px);
  transition: background-color 0.3s ease;
  .home-content {
    background: transparent;
    width: 100% !important;
    max-width: 100%;
  }

  // 所有 max-w-[1520px] 容器使用变量
  .max-w-\[1520px\] {
    max-width: var(--home-max-width);
    padding-left: var(--home-container-px);
    padding-right: var(--home-container-px);
  }

  // 区段间距使用变量
  .courses-section,
  .institutions-section {
    padding-top: var(--home-section-py);
    padding-bottom: calc(var(--home-section-py) * 1.5);
  }

  // 精品课程区域顶部渐变线
  .courses-section-line {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(0, 0, 0, 0.04),
      transparent
    );
  }

  // 推荐机构区域 - 渐变装饰
  .institutions-gradient-bg {
    background: radial-gradient(
      ellipse at top right,
      rgba($saas-theme-color, 0.08) 0%,
      transparent 50%
    );
  }
}

html.dark .home-page-wrap {
  .courses-section-line {
    background: linear-gradient(
      to right,
      transparent,
      rgba(255, 255, 255, 0.06),
      transparent
    );
  }
  .institutions-gradient-bg {
    background: radial-gradient(
      ellipse at top right,
      rgba($saas-theme-color, 0.03) 0%,
      transparent 50%
    );
  }

  // 精品课程区域顶部渐变线
  .courses-section-line {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(0, 0, 0, 0.04),
      transparent
    );
  }

  // 推荐机构区域 - 渐变装饰
  .institutions-gradient-bg {
    background: radial-gradient(
      ellipse at top right,
      rgba($saas-theme-color, 0.08) 0%,
      transparent 50%
    );
  }
}

html.dark .home-page-wrap {
  .courses-section-line {
    background: linear-gradient(
      to right,
      transparent,
      rgba(255, 255, 255, 0.06),
      transparent
    );
  }
  .institutions-gradient-bg {
    background: radial-gradient(
      ellipse at top right,
      rgba($saas-theme-color, 0.03) 0%,
      transparent 50%
    );
  }
}

// h5样式
.home-page-wrap.h5-home-page-wrap {
  min-width: 100%;
  max-width: 100%;
  background: var(--page-bg);
  .home-content {
    width: 100%;
  }
  // Ensure max-w containers are full-width on H5 with mobile-friendly padding
  .max-w-\[1520px\] {
    max-width: 100% !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .courses-section,
  .institutions-section {
    padding: 12px 0 !important;
    margin-top: 0 !important;
    background: transparent !important;
    .courses-section-line {
      display: none;
    }
    .institutions-gradient-bg {
      display: none;
    }
  }
}
</style>
<style lang="scss">
// 覆盖 amfe-flexible 在桌面端设置的超大 html font-size
@media screen and (min-width: 768px) {
  html {
    font-size: 16px !important;
  }
}

// ============ CSS 变量定义 ============
// Web 默认值
.home-page-wrap {
  --home-max-width: 1520px;
  --home-container-px: 2rem;
  --home-section-py: 3rem;

  --banner-height: 500px;
  --banner-radius: 2.5rem;

  --section-title-size: 2.5rem;
  --section-subtitle-size: 1rem;
  --section-title-mb: 2.5rem;

  --card-gap: 1.5rem;
  --card-radius: 2rem;

  --category-icon-size: 48px;
  --category-gap: 1rem;

  --drawer-width: 500px;
  --drawer-radius: 2rem;

  .module-title {
    font-weight: 600;
    font-size: var(--section-title-size);
    color: $saas-text-color;
    line-height: 1.4;
    margin-bottom: var(--section-title-mb);
  }
}

// Electron 覆盖 — 更紧凑
.home-page-wrap.electron-home-page {
  --home-max-width: 100%;
  --home-container-px: 24px;
  --home-section-py: 24px;

  --banner-radius: 16px;

  --section-title-size: 22px;
  --section-subtitle-size: 13px;
  --section-title-mb: 16px;

  --card-gap: 16px;
  --card-radius: 16px;

  --category-icon-size: 36px;
  --category-gap: 8px;

  --drawer-width: 400px;
  --drawer-radius: 16px;
}

// H5 样式
.home-page-wrap.h5-home-page-wrap {
  .module-title {
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 0.6rem;
    margin-bottom: 0.21rem;
  }
}
</style>
